import { faSearch, faFileSearch } from "@fortawesome/pro-regular-svg-icons";

export const SEARCH_BUTTON_ICONS = {
  search: faSearch,
  searchWithin: faFileSearch,
};
